import { AmbientLight, Euler, HemisphereLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { PointInteres } from "../../objects/Tema1/subtopicOne/PointInteres";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CharacterToDress } from "../../objects/Tema1/subtopicOne/CharacterToDress";
import { CameraController } from "../../../componets3D/CameraController";
import { Floor } from "../../objects/Floor";
import { MapLocalSubtopicOne } from "../../objects/Tema1/subtopicOne/MapLocalSubtopicOne";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { City } from "../../objects/Tema1/subtopicOne/City";
import { audiosAssets } from "../../../../assets/audio";
import { PlanoRoomCold } from "../../objects/Tema1/subtopicOne/PlanoRoomCold";
// import { HelperLitght } from "../../../componets3D/HelperLitght";


const _PI_2 = Math.PI / 2;
const _euler = new Euler(0, 0, 0, "YXZ");
export class SceneTopcOne extends Scene {
	constructor(loadingManager, container, render, characterSelected = new CharcterOxxo(), environmentToScenes) {
		super();
		this.renderer = render;
		this.characterSelected = characterSelected;
		this.environment = environmentToScenes;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		// this.light();
		this.observerListteners();
		this.renderAnimations();
		this.ambientCity = null
		this.ambient = null
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new MapLocalSubtopicOne(this.loadingManager);
		this.add(this.mapmenu);

		this.city = new City();
		this.add(this.city);
		this.city.position.y = 500;

		this.pointinteres = new PointInteres(this.loadingManager);
		this.add(this.pointinteres);
		this.pointinteres.visible = false;

		this.characterToDress = new CharacterToDress(this.loadingManager);
		this.add(this.characterToDress);

		this.floor = new Floor(this.loadingManager);
		this.add(this.floor);

		this.planoRoomCold = new PlanoRoomCold(this.loadingManager);

		// this.characterSelected.helpers()

	}

	observerListteners() {
		ObserverEmitter.on(EVENTS.subtopicOne.activityTwo.activeOutline, () => {
			this.camera.control.enableRotate = true;
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.control.enablePan = true;
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityTwo.moveIslanBox, () => {
			// this.camera.control.enableRotate = true;
			// this.camera.control.enablePan = true;
			// this.camera.control.maxAzimuthAngle = Infinity;
			// this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-7.2055, 0.3564, 1.5758), 1, new Vector3(-8.153, -0.077, 1.213), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [
					this.mapmenu.Mostrador001,
				];
				this.mapmenu.onAnimate(this.mapmenu.Mostrador001, 50)
				this.mouseListenersActivityTwo();
			});
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityTwo.moveFloorSale, () => {
			this.camera.moveCameraToPoint(new Vector3(-4.0714, -0.1535, -0.0755), 1, new Vector3(-3.757, -0.272, -0.139), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [
					this.mapmenu.Gondola,
				];
				this.mapmenu.onAnimate(this.mapmenu.Gondola)
				this.mouseListenersActivityTwo();
			});
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityTwo.moveStoreActTwo, () => {
			// this.camera.control.enableRotate = true;
			// this.camera.control.enablePan = true;
			this.camera.moveCameraToPoint(new Vector3(4.9262, 0.2146, -1.9879), 1, new Vector3(5.895, -0.459, 0.888), () => {
				this.camera.moveCameraToPoint(new Vector3(3.1174, -0.3539, 10.1437), 1, new Vector3(6.225, -0.396, 10.113), () => {
					this.mapmenu.onAnimationOpacity(this.mapmenu.Puerta, () => {
						this.camera.moveCameraToPoint(new Vector3(11.851, 0.5907, 9.4084), 1, new Vector3(14.255, -0.165, 7.59), () => {
							this.mouseEvents.disposeInteractions();
							this.mouseEvents.objectsToValue = [
								this.mapmenu.Armario,
							];
							this.mapmenu.onAnimate(this.mapmenu.Armario)
							this.mouseListenersActivityTwo();
						})
					})
				})
			})
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityTwo.moveRoomColdActTwo, () => {
			this.camera.moveCameraToPoint(new Vector3(-0.2267, -0.7043, -0.516), 1, new Vector3(2.877, -0.644, -0.668), () => {
				this.planoRoomCold.onAnimationOpacity()
				this.mapmenu.onAnimate()

				this.add(this.planoRoomCold)

				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [
					this.planoRoomCold.PlaneRoomCold,
				];

				this.mouseListenersActivityTwo();
			})
		});
		ObserverEmitter.on(EVENTS.subtopicOne.activityTwo.moveFoodService, () => {
			this.camera.moveCameraToPoint(new Vector3(-9.1791, -0.2823, -5.0421), 1, new Vector3(-9.797, -0.336, -8.088), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [
					this.mapmenu.Mostrador,
				];
				this.mapmenu.onAnimate(this.mapmenu.Mostrador)
				this.mouseListenersActivityTwo();
			})
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityOne.moveCamareToCharacterDress, () => {
			this.camera.moveCameraToPoint(new Vector3(-8.4668, 0.1941, -5.2105), 1, new Vector3(-4.749, -0.55, -5.019), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(95);
				this.camera.control.minPolarAngle = MathUtils.degToRad(40);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.control.enablePan = false;
			});
		});
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
		this.pointinteres.visible = false;
		this.characterToDress.visible = false;
		this.mapmenu.createSceneGlobal();
		// new HelperOnlyObject("Helado", this.mapmenu.Helado);
	}

	stateSceneIntroduction() {
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();

		this.camera.enabledOrbitControls();
		this.pointinteres.visible = true;
		this.characterToDress.visible = false;
		this.mouseEvents.objectsToValue = this.children;
		this.mouseListenersActivityIntroduction();
	}

	stateSceneActivityOne() {
		this.camera.enabledOrbitControls();
		this.characterSelected.onAnimateSaludo();
		this.pointinteres.visible = false;
		this.characterToDress.onHiddenAllClothes();
		this.characterToDress.visible = false;
		this.mouseEvents.objectsToValue = this.children;

		this.characterSelected.position.set(-6.5728, -1.7985, -4.1512);
		this.characterSelected.rotation.set(0, -1.7968, 0);

		this.characterSelected.visible = true;

		// this.characterSelected.helpers();
	}
	stateSceneActivityTwo() {
		this.mapmenu.onAnimate()
		this.mapmenu.Puerta.material.opacity = 1

		this.renderer.toneMappingExposure = 0.58;
		this.characterSelected.onAnimationFestejo();

		this.mouseEvents.disposeInteractions();
		// this.mouseEvents.objectsToValue = [
		// 	this.floor,
		// 	this.mapmenu.Mostrador001,
		// 	this.mapmenu.Gondola001,
		// 	this.mapmenu.Gondola002,
		// 	this.mapmenu.Refri_coca_1,
		// ];

		this.pointinteres.visible = false;

		this.characterSelected.position.set(-5.9111, -1.7985, -4.1512);
		this.characterSelected.rotation.set(0, -2.8599, 0);

		this.characterSelected.visible = true;

		this.planoRoomCold.position.set(6.5248, -0.4902, -1.3892)
		this.planoRoomCold.rotation.set(0, -1.5766, 0)

		// this.mouseListenersActivityTwo();
	}
	stateSceneActivityThree() {
		this.renderer.toneMappingExposure = 0.95;
		this.city.position.y = 0;
		this.city.visible = true;

		this.city.onAnimate()

		this.mapmenu.visible = false;
		this.mouseEvents.disposeInteractions();
		this.characterToDress.visible = false;
		this.pointinteres.visible = false;

		this.characterSelected.position.set(102.3614, 13.2996, -60.3828)
		this.characterSelected.rotation.set(0.2279, 2.5437, -0.1375)
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateIdle();

		// rayos
		this.city.R_ParadaTecnica.visible = false;
		this.city.R_Barrio.visible = false;
		this.city.R_Hogar.visible = false;
		this.city.R_Clasico.visible = false;
		this.city.R_Oficinistas.visible = false;

		this.mouseEvents.objectsToValue = [];

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.upTower, () => {
			this.camera.moveCameraToPoint(new Vector3(103.7784, 14.2599, -62.2825), 1, new Vector3(-172.144, -129.063, 300), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [
				];
				this.mouseListenersEnableActivityThree()
				this.characterSelected.visible = true
				this.characterSelected.onAnimationFestejo();
				ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.upTowerShowMessage)
			});

		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.initActivityMovement, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(75.7408, 143.2917, 168.1731), 1, new Vector3(-4.621, 22.132, 38.827), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [
				];
				this.mouseListenersEnableActivityThree()
			});

		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.moveStore1, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;

			this.camera.moveCameraToPoint(new Vector3(-126.3652, 12.0443, 157.2216), 3, new Vector3(-160.179, -52.015, -23.392), () => {
				this.camera.moveCameraToPoint(new Vector3(-227.7518, 23.3161, 143.7192), 3, new Vector3(-101.028, -55.587, 18.885), () => {
					this.mouseEvents.disposeInteractions();
					this.mouseEvents.objectsToValue = [
						this.city.OXXO_BARRIO
					];
					this.city.onAnimate(this.city.OXXO_BARRIO, 25)
					this.mouseListenersEnableActivityThree()
				});
			});
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.moveStore2, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-195.4355, 41.614, -56.8565), 3, new Vector3(-94.817, -4.344, -216.956), () => {
				this.camera.moveCameraToPoint(new Vector3(-233.8629, 21.8812, -26.1896), 3, new Vector3(-91.635, -54.924, -134.543), () => {
					this.mouseEvents.disposeInteractions();
					this.mouseEvents.objectsToValue = [
						this.city.OXXO_OFICINA
					];
					this.city.onAnimate(this.city.OXXO_OFICINA, 25)
					this.mouseListenersEnableActivityThree()
				});
			});
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.moveStore3, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			// this.camera.control.enablePan = true
			// this.camera.control.enableRotate = true
			this.camera.moveCameraToPoint(new Vector3(-109.1202, 32.2976, -21.2179), 2, new Vector3(-74.474, -26.116, -203.579), () => {
				this.camera.moveCameraToPoint(new Vector3(-102.6119, 35.654, -128.547), 2, new Vector3(-87.679, -16.922, 58.217), () => {
					this.camera.moveCameraToPoint(new Vector3(3.8266, 29.5739, -62.4553), 3, new Vector3(-183.646, -21.966, -70.565), () => {
						this.camera.moveCameraToPoint(new Vector3(7.7087, 31.0471, -132.9581), 3, new Vector3(-166.196, -23.017, -64.384), () => {
							this.mouseEvents.disposeInteractions();
							this.mouseEvents.objectsToValue = [
								this.city.OXXO_HOGAR_REUNION
							];
							this.city.onAnimate(this.city.OXXO_HOGAR_REUNION)
							this.mouseListenersEnableActivityThree()
						});
					});
				})
			})
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.moveStore4, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-22.6296, 13.8379, -42.277), 3, new Vector3(129.701, -20.229, -158.48), () => {
				this.mouseEvents.disposeInteractions();
				this.mouseEvents.objectsToValue = [
					this.city.OXXO_PARADA_TECNICA
				];
				this.city.onAnimate(this.city.OXXO_PARADA_TECNICA, 25)
				this.mouseListenersEnableActivityThree()
			});
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.moveStore5, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(38.0331, 17.5022, 14.3476), 3, new Vector3(41.986, -41.798, 199.647), () => {
				this.camera.moveCameraToPoint(new Vector3(65.8396, 25.4, -45.2764), 3, new Vector3(213.313, -29.691, 69.111), () => {
					this.mouseEvents.disposeInteractions();
					this.mouseEvents.objectsToValue = [
						this.city.OXXO_CLASICO
					];
					this.city.onAnimate(this.city.OXXO_CLASICO, 25)
					this.mouseListenersEnableActivityThree()
				});
			})
		});
	}

	mouseListenersEnableActivityThree() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoInformacion)
				this.city.onAnimate()
				ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.backClick, name)
			}
		});
	}

	stateSceneActivityFour() {
		this.renderer.toneMappingExposure = 0.95;
		this.city.position.y = 0;
		this.city.visible = true;

		this.mapmenu.visible = false;
		this.mouseEvents.disposeInteractions();
		this.characterToDress.visible = false;
		this.pointinteres.visible = false;

		this.characterSelected.position.set(68, 0, -4)
		this.characterSelected.rotation.set(0, 0.4246, 0)
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateIdle();

		// rayos
		this.city.R_ParadaTecnica.visible = false;
		this.city.R_Barrio.visible = false;
		this.city.R_Hogar.visible = false;
		this.city.R_Clasico.visible = false;
		this.city.R_Oficinistas.visible = false;

		this.mouseEvents.objectsToValue = [];

		ObserverEmitter.on(EVENTS.subtopicOne.activityThree.initActivityMovement, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			const selectOxxo = localStorage.getItem("oxxoTienda") ?? "1"
			const oxxoRay = [
				{
					id: "1",
					name: "OXXO_OFICINA",
					ray: "R_Oficinistas"
				},
				{
					id: "2",
					name: "OXXO_HOGAR_REUNION001",
					ray: "R_ParadaTecnica"
				},
				{
					id: "3",
					name: "OXXO_HOGAR_REUNION",
					ray: "R_Hogar"
				},
				{
					id: "4",
					name: "OXXO_BARRIO",
					ray: "R_Barrio"
				},
				{
					id: "5",
					name: "OXXO_CLASICO",
					ray: "R_Clasico"
				}
			]
			const findOxxo = oxxoRay.find((ox) => ox.id === selectOxxo)
			this.city[findOxxo.ray].visible = true
			this.selectOxxoGame = { name: findOxxo.name, ray: findOxxo.ray }
			this.camera.moveCameraToPoint(new Vector3(75.7408, 143.2917, 168.1731), 3, new Vector3(-4.621, 22.132, 38.827), () => {
				this.mouseEvents.objectsToValue = [this.city];
				this.camera.moveCameraToPoint(new Vector3(-21.9041, 7.7925, 136.3951), 1, new Vector3(-22.04, 7.071, 132.307), () => {
					this.mouseEvents.disposeInteractions();
					this.camera.disabledOrbitControls();
					ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.openClock)
					this.mouseListenersActivityThree();
				});
			});

		});

		// this.characterSelected.helpers();
	}

	stateSceneActivityFive() {
		this.city.position.y = 500;
		this.renderer.toneMappingExposure = 0.58;
		this.city.visible = false;
		this.mapmenu.visible = true;
		this.mouseEvents.disposeInteractions();
		this.characterSelected.visible = true;
		this.characterSelected.onAnimateSaludo();
		this.pointinteres.visible = false;
		this.characterToDress.visible = false;

		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);

		// this.characterSelected.helpers();
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.light();
				this.camera.moveCameraToPoint(new Vector3(-12.635, 0.1737, -0.7827), 1, new Vector3(-10.947, -0.327, -1.755), () => {
					this.stateSceneIntroduction();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = -0.86;
					// this.camera.control.minAzimuthAngle = -2;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			// * activity one
			case 1:
				this.light();
				this.camera.moveCameraToPoint(new Vector3(-9.0207, -1.2046, -4.8076), 1, new Vector3(-5.37, -1.325, -3.774), () => {
					this.stateSceneActivityOne();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(95);
					this.camera.control.minPolarAngle = MathUtils.degToRad(40);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1.5;
					this.camera.control.maxDistance = 5;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			//  * activity two
			case 2:
				this.light();
				this.camera.moveCameraToPoint(new Vector3(-6.596, -1.1078, -6.5425), 1, new Vector3(-6.231, -1.177, -5.504), () => {
					this.stateSceneActivityTwo();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(95);
					this.camera.control.minPolarAngle = MathUtils.degToRad(40);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = Infinity;
					// this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 5;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 3:
				this.lightCity()
				this.camera.enabledOrbitControls();
				this.camera.moveCameraToPoint(new Vector3(103.7784, 14.2599, -62.2825), 1, new Vector3(-172.144, -129.063, 300), () => {
					this.stateSceneActivityThree();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(80);
					this.camera.control.minPolarAngle = MathUtils.degToRad(40);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 0.1;
					this.camera.control.maxDistance = 500;
					this.camera.control.enableZoom = false;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 4:
				this.lightCity()
				this.camera.enabledOrbitControls();
				this.camera.moveCameraToPoint(new Vector3(69.1935, 0.505, -1.1541), 1, new Vector3(-141.447, -108.609, -441.296), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(80);
					this.camera.control.minPolarAngle = MathUtils.degToRad(40);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 0.1;
					this.camera.control.maxDistance = 500;
					this.camera.control.enableZoom = false;
					this.camera.control.enablePan = false;
					this.stateSceneActivityFour();
					this.activeAudio()
				});
				break;

			case 5:
				this.light();
				this.camera.enabledOrbitControls();
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.stateSceneActivityFive();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(50);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;

			default:
				this.light();
				this.camera.moveCameraToPoint(new Vector3(-5.5414, -0.5067, -6.0085), 1, new Vector3(-5.023, -0.639, -5.044), () => {
					// this.camera.disabledOrbitControls();
					// this.stateSceneActivityTwo();
					this.camera.control.maxPolarAngle = MathUtils.degToRad(95);
					this.camera.control.minPolarAngle = MathUtils.degToRad(40);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 5;
					this.camera.control.enablePan = false;
					this.characterSelected.visible = false;
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		if (this.ambientCity) {
			this.remove(this.ambientCity)
		}
		if (this.ambient) {
			return
		}
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	lightCity() {
		if (this.ambient) {
			this.remove(this.ambient)
		}
		if (this.ambientCity) {
			return
		}
		this.ambientCity = new HemisphereLight()
		// this.ambientCity.color.set(0x99DDFF)
		this.ambientCity.color.set(0x93acb9)
		this.ambientCity.groundColor.set(0xA9A984)
		this.ambientCity.intensity = 2.9;
		this.ambientCity.position.y = 23
		// this.helperLight = new HelperLitght("Ambiente fuera", this.ambientCity);
		this.add(this.ambientCity)
	}

	mouseListenersActivityIntroduction() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				switch (interactions[0].object.name) {
					case "Lathe":
						ObserverEmitter.emit(EVENTS.subtopicOne.introduction.initDialog);
						this.characterSelected.visible = true;
						this.pointinteres.visible = false;
						break;

					default:
						break;
				}
			}
		});
	}

	mouseListenersActivityTwo() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name
				if (name === "PlaneRoomCold") {
					this.planoRoomCold.clearAnimation()
				}
				ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.showArea, name);
			}

			// if (interactions[0] && interactions[0].object.name === "Piso") {
			// } else {
			// 	if (interactions[0] && interactions[0].object.name === "Mostrador001") {
			// 		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoInformacion)
			// 		ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.showArea, 1);
			// 		this.mapmenu.stopAnimationsMostrador();
			// 	} else if (interactions[0]) {
			// 		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoInformacion)
			// 		ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.showArea, 2);
			// 		this.mapmenu.stopAnimationsGondola();
			// 	}
			// }

		});
		// this.mouseEvents.onPointerDrag((e) => {
		// 	const movementX = e.movementX || e.mozMovementX || e.webkitMovementX || 0;
		// 	const movementY = e.movementY || e.mozMovementY || e.webkitMovementY || 0;

		// 	_euler.setFromQuaternion(this.camera.quaternion);
		// 	_euler.y -= movementX * 0.002 * 1.0;
		// 	_euler.x -= movementY * 0.002 * 1.0;
		// 	_euler.x = Math.max(_PI_2 - Math.PI, Math.min(_PI_2 - 0, _euler.x));
		// 	this.camera.quaternion.setFromEuler(_euler);
		// });
	}

	mouseListenersActivityThree() {
		this.oxxosAvailable = ["OXXO_PARADA_TECNICA", "OXXO_OFICINA", "OXXO_HOGAR_REUNION", "OXXO_CLASICO", "OXXO_BARRIO"];
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0] && interactions[0].object.name === "CALLE") {
				this.camera.moveCameraToPoint(
					new Vector3(interactions[0].point.x, 7.7925, interactions[0].point.z),
					1,
					new Vector3(0, 0, 0),
					() => { }
				);
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoAvazar)
			}
			if (interactions[0]) {
				if (this.selectOxxoGame.name === interactions[0].object.name) {
					this.city[this.selectOxxoGame.ray].visible = false;
					ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.openModalOxxo)
				}
			}
		});
		this.mouseEvents.onPointerDrag((e) => {
			const movementX = e.movementX || e.mozMovementX || e.webkitMovementX || 0;
			const movementY = e.movementY || e.mozMovementY || e.webkitMovementY || 0;

			_euler.setFromQuaternion(this.camera.quaternion);
			_euler.y -= movementX * 0.002 * 1.0;
			_euler.x -= movementY * 0.002 * 1.0;
			_euler.x = Math.max(_PI_2 - Math.PI, Math.min(_PI_2 - 0, _euler.x));
			this.camera.quaternion.setFromEuler(_euler);
		});
	}

	renderAnimations(delta) {
		this.characterToDress.renderAnimations(delta);
	}
}
